import React, { Fragment, useEffect, useState } from 'react';
import GridCellWrapper from '../../../components/grid-cell-wrapper/GridCellWrapper';
import DropDown from '../../../components/dropdown/Dropdown';
import Toolbar from '../../../components/toolbar/Toolbar';
import Auftragoverview from './auftragoverview/Auftragoverview';
import Services from './services/Services';
import Auftragspositionen from './auftragspositionen/Auftragspositionen';

import { connect } from 'react-redux';
import {
  getAuftragById,
  getAuftragByVorlageAuftragId,
  getAuftragCopyByAuftragId,
  getCurrentBenutzerById,
  resetAuftragserfassung,
  saveAuftrag,
  setAdresse,
  setAuftragField,
  setBeladedatum,
  setEmpfaengerreferenz,
  setEntladedatum,
  setEntladezeitBis,
  setEntladezeitVon,
  setZustellkennzeichen,
  updateAuftrag,
} from '../../../redux/actions/auftragserfassung';
import Modal from '../../../components/modal/Modal';
import Vr from '../../../components/vr/vr';
import Button from '../../../components/button/Button';
import {
  ABWEICHENDE_BELADESTELLE,
  ABWEICHENDER_RECHNUNGSEMPFAENGER_EMPFAENGER,
  ABWEICHENDER_RECHNUNGSEMPFAENGER_VERSENDER,
  EMPFAENGER,
  findAdresseByTyp,
  getAdresseTypLabel,
  getGridCellActiveComponentLabel,
  NACHNAHME_EMPFAENGER,
  NEUTRALE_ABSENDERADRESSE,
  replaceAdresseByTyp,
  resetAdresseToDefault,
  VERSENDER,
} from './adresse/AdresseTypen';
import { AuftragPositionModel } from '../../../models/AuftragPositionModel';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { setActiveTab } from '../../../redux/actions/routing';
import { StateModel } from '../../../redux/store';
import {
  convertToLocaleDateAndTime,
  isoDateToDate,
  isoDateToDateAndTime,
  nextWorkingDayFromDate,
} from '../../../utils/date';

import { getZustellkennzeichen } from '../../../redux/actions/zustellkennzeichen';
import { ReportModel } from '../../../models/ReportModel';
import { getReports, printReports } from '../../../redux/actions/reports';

import {
  Adresse,
  Auftrag,
  Mandant,
  MandantSummary,
  Message,
} from '../../../api';
import InputFieldText from '../../../components/input/floating-label/input-field/InputFieldText';
import Select from '../../../components/select/Select';
import { ZustellkennzeichenModel } from '../../../models/ZustellkennzeichenModel';
import Allgemein from './allgemein/Allgemein';
import NachnahmeWrapper from './adresse/versenderInfo/NachnahmeWrapper';
import VersenderWrapper from './adresse/versenderInfo/VersenderWrapper';
import { getAnlieferkennzeichen } from '../../../redux/actions/anlieferkennzeichen';
import { getMandantenByHauptmandant } from '../../../redux/actions/mandant';
import {
  removeNotifications,
  setNotification,
} from '../../../utils/notificationUtils';
import Hinweise from './hinweise/Hinweise';
import { nameof } from '../../../utils/objectUtils';
import { toSelectOptions } from '../../../components/select/SelectModel';
import { getAdresseOfMandant } from '../../../redux/actions/adresse';
import { History } from 'history';
import SliderCheckbox from '../../../components/slidercheckbox/SliderCheckbox';
import { createAdresse } from '../../../redux/actions/adresserfassung';
import { setModalConfig } from '../../../redux/actions/modal';
import { buildAuftragPayload } from './payloadBuilder';
import { AuftragModel } from '../../../models/AuftragModel';
import { WaehrungModel } from '../../../models/WaehrungModel';
import {
  addNotifications,
  setNotificationField,
} from '../../../redux/actions/notification';
import AdresseFelder from './adresse/adressefelder/Adressefelder';
import Auftragsvorlageerfassung from '../auftragsvorlage/erfassung/Auftragsvorlageerfassung';
import { resetAuftragsvorlageerfassung } from '../../../redux/actions/auftragsvorlageerfassung';
import { ConfigModel } from '../../../models/ConfigModel';
import { setCurrentMandantId } from '../../../redux/actions/user-session';
import Preisanzeige from './preisanzeige/Preisanzeige';
import { AdresseModel } from '../../../models/AdresseModel';
import {
  DLA_ID_BEXITY_BEX,
  DLA_ID_BEXITY_RS,
  LAND_ID_AT,
} from '../../../utils/constants';
import { AuftragServiceModel } from '../../../models/AuftragServiceModel';
import { AuftragDefaultServiceModel } from '../../../models/AuftragDefaultServiceModel';
import { getDynamicAuftragServices } from '../../../redux/actions/defaultAuftragServices';
import { toNumber } from 'lodash';
import { ServiceModel } from '../../../models/ServiceModel';

interface AuftragserfassungProps {
  versender: Adresse;
  empfaenger: Adresse;
  currentVersender: any;
  currentEmpfaenger: any;
  auftragserfassung: any;
  currentAuftragpos: Array<AuftragPositionModel>;
  saveAuftrag: (auftrag: AuftragModel, onSaveSuccess: () => void) => void;
  updateAuftrag: (
    id: number,
    auftragDto: AuftragModel,
    onSaveSuccess: () => void,
    options?: any
  ) => void;
  resetAuftragserfassung: (history?: History) => void;
  getAuftragById: (value: number) => void;
  getAuftragCopyByAuftragId: (value: number) => void;
  getAnlieferkennzeichen: (mandantId: number) => void;
  getZustellkennzeichen: (mandantId: number) => void;
  getReports: () => void;
  reports: Array<ReportModel>;
  printReports: (auftragIDs: number[], report: ReportModel) => void;
  setEntladedatum: (value: string | undefined) => void;
  setEntladezeitVon: (value: string | undefined) => void;
  setEntladezeitBis: (value: string | undefined) => void;
  setEmpfaengerreferenz: (value: string | undefined) => void;
  setZustellkennzeichen: (value: number | undefined) => void;
  zustellkennzeichen: ZustellkennzeichenModel[];
  isHauptmandant: boolean;
  isAdmin: boolean;
  isMain: boolean;
  mandanten: MandantSummary[];
  getMandantenByHauptmandant: () => void;
  getDynamicAuftragServices: () => void; //#84367
  setAuftragField: (value: any, fieldname: string) => void;
  stammWaehrungen: WaehrungModel[];
  getAdresseOfMandant: (mandantId: number) => void;
  currentMandant: Mandant;
  currentMandantId: string;
  resetAuftragsvorlageerfassung: () => void;
  isEditVorlage: boolean;
  isAuftragEdit: boolean;
  createAdresse: (payload: Adresse) => void;
  setModalConfig: (value: any, fieldName: string) => void;
  setNotificationField: (value: any, fieldName: string) => void;
  setAdresse: (addressType: string, value: any, key: string) => void;
  notifications: any;
  isDisableUhrzeitfelder?: boolean;
  addNotifications: (messages?: Message[]) => void;
  config: ConfigModel;
  version: number;
  setCurrentMandantId: (id: number | undefined) => void;
  getAuftragByVorlageAuftragId: (value: number) => void;
  currentBenutzerId: string | undefined;
  auth_user_id: string | undefined;
  getCurrentBenutzerById: (id: number) => void;
  auftragServices: Array<AuftragServiceModel>;
  dynamicServices: AuftragDefaultServiceModel[];
  currentServices: ServiceModel[];
}

/**
 * Auftragserfassung-Component
 * Dient zur Erfassung von Aufträgen.
 *
 * @returns {JSX.Element} Auftragserfassung-Component
 * @constructor
 */
const Auftragserfassung = ({
  auftragserfassung,
  getAuftragById,
  getAuftragCopyByAuftragId,
  getAuftragByVorlageAuftragId,
  getDynamicAuftragServices,
  saveAuftrag,
  updateAuftrag,
  resetAuftragserfassung,
  history,
  getAnlieferkennzeichen,
  getZustellkennzeichen,
  setEntladedatum,
  setEntladezeitVon,
  setEntladezeitBis,
  setEmpfaengerreferenz,
  setZustellkennzeichen,
  zustellkennzeichen,
  reports,
  getReports,
  printReports,
  isHauptmandant,
  isAdmin,
  isMain,
  mandanten,
  getMandantenByHauptmandant,
  setAuftragField,
  stammWaehrungen,
  getAdresseOfMandant,
  currentMandant,
  currentVersender,
  currentMandantId,
  resetAuftragsvorlageerfassung,
  isEditVorlage,
  isAuftragEdit,
  setModalConfig,
  createAdresse,
  setNotificationField,
  setAdresse,
  isDisableUhrzeitfelder,
  addNotifications,
  config,
  version,
  setCurrentMandantId,
  currentBenutzerId,
  getCurrentBenutzerById,
  auth_user_id,
  dynamicServices,
}: AuftragserfassungProps & RouteComponentProps) => {
  const [show, setShowModal] = useState(false);
  const [activeVersenderTab, setActiveVersenderTab] = useState(VERSENDER);
  const [activeEmpfaengerTab, setActiveEmpfaengerTab] = useState(EMPFAENGER);
  const [showModalVorlageEdit, setShowModalVorlageEdit] = useState(false);
  const [showModalPreisanzeige, setShowModalPreisanzeige] = useState(false);
  // const [auftragServices,setAuftragServices]  useState(false);
  const auftragId = location.pathname.split('/')[4];
  const isBEXITY = config.clientKunde?.toUpperCase() === 'BEXITY';
  const denyOrderEdit = config.denyOrderEdit;
  const canSaveTemplate =
    (version === 0 && isAuftragEdit) ||
    (version > 0 && isAuftragEdit && isMain);
  const [erfasser, setErfasser] = useState(undefined);
  const [zustelldatumEditDeny, setZustelldatumEditDeny] = useState(false);
  if (config.denyOrderEdit) {
    isAuftragEdit = false;
  }
  const zustelldatumOffset = config.zustelldatum_offset;

  useEffect(() => {
    wechselMandant(Number(currentMandantId));
    getZustellkennzeichen(auftragserfassung.mandant?.id ?? -1);
    getAnlieferkennzeichen(auftragserfassung.mandant?.id ?? -1);
    getReports();
    getMandantenByHauptmandant();
    getDynamicAuftragServices();
    getCurrentBenutzerById(
      currentBenutzerId != undefined
        ? Number(currentBenutzerId)
        : Number(auth_user_id)
    );

    const auftragId = location.pathname.split('/')[4];
    if (!!auftragserfassung.copyId) {
      getAuftragCopyByAuftragId(auftragserfassung.copyId);
    } else if (auftragserfassung.vorlageAuftragId) {
      getAuftragByVorlageAuftragId(auftragserfassung.vorlageAuftragId);
    } else if (!!auftragId) {
      getAuftragById(Number(auftragId));
    } else {
      reset();
    }
  }, []);

  useEffect(() => {
    setAbsenderAdresse();
  }, [auftragserfassung?.resetToggle]);

  useEffect(() => {
    if (!auftragserfassung?.id) setBexityCustomerSpecificDLA();
  }, [
    auftragserfassung?.adressen,
    auftragserfassung.anlieferkennzeichen,
    auftragserfassung.zustellkennzeichen,
  ]);

  useEffect(() => {
    if (config.isDenyZustelldatum) {
      setZustelldatumEditDeny(true);
      if (
        auftragserfassung.terminkennzeichen ===
        toNumber(config.terminArtFixTermin)
      ) {
        setZustelldatumEditDeny(false);
      } else if (config.isEntladedatumVorbelegen && isBEXITY) {
        setEntladedatum(
          isoDateToDate(
            nextWorkingDayFromDate(
              isoDateToDate(auftragserfassung?.beladedatum),
              zustelldatumOffset
            )
          )
        );
      }
    }
  }, [auftragserfassung.terminkennzeichen]);

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        setShowModal(true);
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  /**
   * Dient zum Tab-Wechsel
   * @param newActiveTab Key des neuen Tabs
   */
  const switchTab = (newActiveTab: string) => {
    const gridCellLabel = getGridCellActiveComponentLabel(newActiveTab);

    if (
      (auftragserfassung.isCreateAbsender && gridCellLabel === VERSENDER) ||
      (auftragserfassung.isCreateEmpfaenger && gridCellLabel === EMPFAENGER)
    ) {
      createTabModal(gridCellLabel, newActiveTab);
    } else {
      gridCellLabel === VERSENDER
        ? setActiveVersenderTab(newActiveTab)
        : setActiveEmpfaengerTab(newActiveTab);
    }
  };

  /**
   * Erzeugt ein Modales Fenster zum Wechseln des Tabs,
   * während die Anlage noch nicht abgeschlossen wurde.
   *
   * @param gridCellLabel GridCellLabel Versender oder Empfaenger
   * @param newActiveTab Key des neuen Tabs
   */
  const createTabModal = (gridCellLabel: string, newActiveTab: string) => {
    setModalConfig(true, 'show');
    setModalConfig('Adressanlage', 'title');
    setModalConfig('400px', 'width');
    setModalConfig('175px', 'height');
    setModalConfig(
      'Wollen Sie die Adresse vom Typ ' +
        getAdresseTypLabel(
          gridCellLabel === VERSENDER ? activeVersenderTab : activeEmpfaengerTab
        ) +
        ' anlegen?',
      'description'
    );
    setModalConfig(
      <div className='modal-btn-group'>
        <button
          className='modal-btn'
          onClick={() => {
            createAdresse(
              findAdresseByTyp(
                auftragserfassung.adressen,
                gridCellLabel === VERSENDER
                  ? activeVersenderTab
                  : activeEmpfaengerTab
              )
            );
            setModalConfig(false, 'show');
          }}
        >
          Ja
        </button>
        <button
          className='modal-btn'
          onClick={() => {
            resetAdresse(gridCellLabel);
            gridCellLabel === VERSENDER
              ? setActiveVersenderTab(newActiveTab)
              : setActiveEmpfaengerTab(newActiveTab);
            setNotificationField(undefined, 'activeComponent');
            removeNotifications();
            setAuftragField(
              false,
              gridCellLabel === VERSENDER
                ? 'isCreateAbsender'
                : 'isCreateEmpfaenger'
            );
            setModalConfig(false, 'show');
          }}
        >
          Nein
        </button>
      </div>,
      'children'
    );
  };
  //#81844 currentMandantId hinzugenommen sonst keine Adresse bei F5
  useEffect(() => {
    if (
      auftragserfassung.vorlageAuftragId === undefined &&
      (auftragserfassung.mandant?.id || currentMandantId)
    ) {
      setAbsenderAdresse();
    }
  }, [auftragserfassung.mandant?.id, currentMandantId]);

  const printReport = (report: ReportModel) => {
    const auftragId = auftragserfassung.id;

    if (auftragId) {
      const list: number[] = [Number(auftragId)];
      printReports(list, report);
    } else {
      setNotification('Auftrag muss erst Gespeichert werden.', []);
    }

    return null;
  };

  const setAbsenderAdresse = () => {
    if (!auftragId) {
      if (currentMandantId && Number(currentMandantId) != -1) {
        getAdresseOfMandant(Number(currentMandantId));
      } else if (isHauptmandant && auftragserfassung.mandant?.id) {
        getAdresseOfMandant(auftragserfassung.mandant?.id);
      } else if (currentMandant && currentMandant.id) {
        setCurrentMandantId(currentMandant.id);
        getAdresseOfMandant(Number(currentMandant.id));
      }
    }
  };

  const reset = (history?: History) => {
    resetAuftragserfassung(history);
    removeNotifications();
    setAbsenderAdresse();
    setIsCreateAbsender(false);
    setIsCreateEmpfaenger(false);
    setActiveVersenderTab(VERSENDER);
    setActiveEmpfaengerTab(EMPFAENGER);
  };

  const setIsCreateAbsender = (value: boolean) => {
    if (
      !(
        auftragserfassung.adressen.find(
          (adresse: any) => adresse.typ === activeVersenderTab
        )?.id && auftragserfassung.isCreateAbsender
      )
    ) {
      resetAdresse(VERSENDER);
    }
    if (!value) setAbsenderAdresse();
    setAuftragField(value, 'isCreateAbsender');
    removeNotifications();
  };

  const setIsCreateEmpfaenger = (value: boolean) => {
    if (
      !(
        auftragserfassung.adressen.find(
          (adresse: any) => adresse.typ === activeEmpfaengerTab
        )?.id && auftragserfassung.isCreateEmpfaenger
      )
    ) {
      resetAdresse(EMPFAENGER);
    }
    setAuftragField(value, 'isCreateEmpfaenger');
    removeNotifications();
  };

  const resetAdresse = (gridCellLabel: string) => {
    const tmpAdressen = [...auftragserfassung.adressen];
    const adresseByTyp = findAdresseByTyp(
      tmpAdressen,
      gridCellLabel === VERSENDER ? activeVersenderTab : activeEmpfaengerTab
    );

    setNotificationField(undefined, 'activeComponent');
    setAuftragField(
      replaceAdresseByTyp(
        tmpAdressen,
        resetAdresseToDefault(adresseByTyp),
        gridCellLabel === VERSENDER ? activeVersenderTab : activeEmpfaengerTab
      ),

      'adressen'
    );
  };

  /**
   * Steuert die Schließung vom Modalen Fenster und leert den State der Felder.
   */
  const handleClose = () => {
    setShowModal(false);
  };

  const auftragserfassungAbbrechen = (history?: History) => {
    reset(history);

    handleClose();

    if (history) {
      setActiveTab('auftragsmanagement');
      history.push(`/auftragsmanagement/auftragsresearch`);
    }

    if (config.isBeladedatumVorbelegen) setBeladedatum(new Date());
  };

  /**
   * Steuert die Schließung vom Modalen Fenster und leert den State der Felder.
   */
  const closeAuftragsvorlage = () => {
    resetAuftragsvorlageerfassung();
    setShowModalVorlageEdit(false);
  };

  const closePreisanzeige = () => {
    setShowModalPreisanzeige(false);
  };

  const getWorktabsVersender = () => {
    function getSliderdisable() {
      if (activeVersenderTab === VERSENDER && config.isAbsenderEditDeny) {
        return true;
      }
      return false;
    }

    return (
      <div className='work-tabs'>
        <button
          onClick={() => switchTab(VERSENDER)}
          className={`${
            activeVersenderTab === VERSENDER
              ? 'active'
              : findAdresseByTyp(auftragserfassung.adressen, VERSENDER)?.id &&
                activeVersenderTab !== VERSENDER
              ? '_selected'
              : ''
          }`}
          title={findAdresseByTyp(auftragserfassung.adressen, VERSENDER)?.name}
        >
          Absender
        </button>
        <button
          onClick={() => switchTab(ABWEICHENDE_BELADESTELLE)}
          className={`${
            activeVersenderTab === ABWEICHENDE_BELADESTELLE
              ? 'active'
              : findAdresseByTyp(
                  auftragserfassung.adressen,
                  ABWEICHENDE_BELADESTELLE
                )?.id && activeVersenderTab !== ABWEICHENDE_BELADESTELLE
              ? '_selected'
              : ''
          }`}
          title={
            findAdresseByTyp(
              auftragserfassung.adressen,
              ABWEICHENDE_BELADESTELLE
            )?.name
          }
        >
          {config.isShowAbsenderNeutral && 'abw. Abh.'}
          {!config.isShowAbsenderNeutral && 'abw. Abholung'}
        </button>
        <button
          onClick={() => switchTab(ABWEICHENDER_RECHNUNGSEMPFAENGER_VERSENDER)}
          className={`${
            activeVersenderTab === ABWEICHENDER_RECHNUNGSEMPFAENGER_VERSENDER
              ? 'active'
              : findAdresseByTyp(
                  auftragserfassung.adressen,
                  ABWEICHENDER_RECHNUNGSEMPFAENGER_VERSENDER
                )?.id &&
                activeVersenderTab !==
                  ABWEICHENDER_RECHNUNGSEMPFAENGER_VERSENDER
              ? '_selected'
              : ''
          }`}
          title={
            findAdresseByTyp(
              auftragserfassung.adressen,
              ABWEICHENDER_RECHNUNGSEMPFAENGER_VERSENDER
            )?.name
          }
        >
          Rechnung
        </button>

        <button
          onClick={() => switchTab(NACHNAHME_EMPFAENGER)}
          className={`${
            activeVersenderTab === NACHNAHME_EMPFAENGER
              ? 'active'
              : (findAdresseByTyp(
                  auftragserfassung.adressen,
                  NACHNAHME_EMPFAENGER
                )?.id &&
                  activeVersenderTab !== NACHNAHME_EMPFAENGER) ||
                auftragserfassung.nachnahmeBetrag
              ? '_selected'
              : ''
          }`}
          title={
            findAdresseByTyp(auftragserfassung.adressen, NACHNAHME_EMPFAENGER)
              ?.name
          }
        >
          Nachnahme
        </button>
        {config.isShowAbsenderNeutral && (
          <button
            onClick={() => switchTab(NEUTRALE_ABSENDERADRESSE)}
            className={`${
              activeVersenderTab === NEUTRALE_ABSENDERADRESSE
                ? 'active'
                : findAdresseByTyp(
                    auftragserfassung.adressen,
                    NEUTRALE_ABSENDERADRESSE
                  )?.id && activeVersenderTab !== NEUTRALE_ABSENDERADRESSE
                ? '_selected'
                : ''
            }`}
            title={
              findAdresseByTyp(
                auftragserfassung.adressen,
                NEUTRALE_ABSENDERADRESSE
              )?.name
            }
          >
            Neutral
          </button>
        )}
        {isAuftragEdit && (
          <SliderCheckbox
            disabled={getSliderdisable()}
            value={auftragserfassung.isCreateAbsender}
            onChangeHandler={setIsCreateAbsender}
            labelActive={<i className='fas fa-user-plus' />}
            labelInactive={<i className='fas fa-search' />}
          />
        )}
      </div>
    );
  };

  const getWorktabsEmpfaenger = () => {
    return (
      <div className='work-tabs'>
        <button
          onClick={() => switchTab(EMPFAENGER)}
          className={`${
            activeEmpfaengerTab === EMPFAENGER
              ? 'active'
              : findAdresseByTyp(auftragserfassung.adressen, EMPFAENGER)?.id &&
                activeEmpfaengerTab !== EMPFAENGER
              ? '_selected'
              : ''
          }`}
          title={findAdresseByTyp(auftragserfassung.adressen, EMPFAENGER)?.name}
        >
          Empfänger
        </button>
        {config.isShowEmpfRechnung && (
          <button
            onClick={() =>
              switchTab(ABWEICHENDER_RECHNUNGSEMPFAENGER_EMPFAENGER)
            }
            className={`${
              activeEmpfaengerTab ===
              ABWEICHENDER_RECHNUNGSEMPFAENGER_EMPFAENGER
                ? 'active'
                : findAdresseByTyp(
                    auftragserfassung.adressen,
                    ABWEICHENDER_RECHNUNGSEMPFAENGER_EMPFAENGER
                  )?.id &&
                  activeEmpfaengerTab !==
                    ABWEICHENDER_RECHNUNGSEMPFAENGER_EMPFAENGER
                ? '_selected'
                : ''
            } `}
            title={
              findAdresseByTyp(
                auftragserfassung.adressen,
                ABWEICHENDER_RECHNUNGSEMPFAENGER_EMPFAENGER
              )?.name
            }
          >
            Rechnung
          </button>
        )}
        {isAuftragEdit && (
          <SliderCheckbox
            value={auftragserfassung.isCreateEmpfaenger}
            onChangeHandler={setIsCreateEmpfaenger}
            labelActive={<i className='fas fa-user-plus' />}
            labelInactive={<i className='fas fa-search' />}
            disabled={false}
          />
        )}
      </div>
    );
  };

  const wechselMandant = (id?: number) => {
    resetAuftragserfassung();
    const mandant = mandanten.find(mandant => mandant.id === id);
    setAuftragField(mandant, nameof<Auftrag>('mandant'));

    setCurrentMandantId(mandant?.id ?? -1);
    getZustellkennzeichen(mandant?.id ?? -1);
    getAnlieferkennzeichen(mandant?.id ?? -1);
  };

  const disablePreisButton = () => {
    return (
      auftragserfassung.kf_id === undefined || auftragserfassung.kf_id === null
    );
  };

  /**
   * Wird ausgefuehrt nach erfolgreichem speichern (in der Action).
   */
  const onSaveSuccess = () => {
    setAbsenderAdresse();
  };

  /**
   * Setzt BEXity-Kundenspezifisch die DLA.
   */
  const setBexityCustomerSpecificDLA = () => {
    if (!isBEXITY) return;
    let versenderAdresse = auftragserfassung.adressen.find(
      (item: AdresseModel) => item.typ === VERSENDER
    );
    const empfaengerAdresse = auftragserfassung.adressen.find(
      (item: AdresseModel) => item.typ === EMPFAENGER
    );
    const abwAbholadresse = auftragserfassung.adressen.find(
      (item: AdresseModel) => item.typ === ABWEICHENDE_BELADESTELLE
    );
    if (abwAbholadresse.id) {
      versenderAdresse = abwAbholadresse;
    }
    let dla = DLA_ID_BEXITY_BEX;

    if (
      //Vers. oder Empf. nicht AT??
      versenderAdresse?.land?.id &&
      empfaengerAdresse?.land?.id &&
      (versenderAdresse?.land?.id !== LAND_ID_AT ||
        empfaengerAdresse?.land?.id !== LAND_ID_AT)
    ) {
      dla = DLA_ID_BEXITY_RS;

      if (
        //Anl. oder Zusst.-Kennzeichen vorhanden?
        auftragserfassung.zustellkennzeichen ||
        auftragserfassung.anlieferkennzeichen
      ) {
        if (
          //Anliefer oder Zustellkennzeichen bei NICHT AT Adresse, dann BEX
          (versenderAdresse.land.id != LAND_ID_AT &&
            auftragserfassung.anlieferkennzeichen) ||
          (empfaengerAdresse.land.id != LAND_ID_AT &&
            auftragserfassung.zustellkennzeichen)
        ) {
          dla = DLA_ID_BEXITY_BEX;
        } else {
          //Kein Anl.- oder Zust.-Kennzeichen aber eine NICHT AT Adresse vorhanden dann RS
          dla = DLA_ID_BEXITY_RS;
        }
      } else dla = DLA_ID_BEXITY_RS;
    }
    setAuftragField(dla, 'verkehrsart');
  };

  /**
   * Funktion des Speichern Button in der Auftragserfassung.
   */
  const onSubmitHandler = () => {
    removeNotifications();
    if (
      !auftragserfassung.isCreateAbsender &&
      !auftragserfassung.isCreateEmpfaenger
    ) {
      if (!!auftragserfassung.id) {
        updateAuftrag(
          auftragserfassung.id,
          buildAuftragPayload(auftragserfassung, stammWaehrungen, config),
          onSaveSuccess,
          history
        );
      } else {
        saveAuftrag(
          buildAuftragPayload(auftragserfassung, stammWaehrungen, config),
          onSaveSuccess
        );
      }

      /* SBiT ausgesternt, wenn beim Speichern eine Meldung kommt,
            dass z.B. Terminart nicht gültig ist, ist immerwieder die Empfängeradresse weg,
            obwohl der Auftrag nicht gespeichert werden kann..
            setIsCreateAbsender(false);
            setActiveVersenderTab(VERSENDER);
            setIsCreateEmpfaenger(false);
            setActiveEmpfaengerTab(EMPFAENGER);

             */
    } else {
      setModalConfig(true, 'show');
      setModalConfig('Adresse', 'title');
      setModalConfig('400px', 'width');
      setModalConfig('110px', 'height');
      setModalConfig(
        'Die Adresseanlage wurde nicht abgeschlossen.',
        'description'
      );
      setModalConfig(undefined, 'children');
    }
  };

  return (
    <Fragment>
      <div
        className={`wrapper${
          !config.isServicesInternSendungen
            ? ' kein-service-intern-sendungen'
            : ''
        }`}
      >
        <Toolbar>
          {isAuftragEdit && (
            <Button
              tooltip={'Speichern'}
              key={0}
              classes={`iconButton ${
                auftragserfassung.status?.id >= 2 && 'disabled'
              }`}
              onClickHandler={() => onSubmitHandler()}
            >
              <i className='far fa-save fa-2x' />
            </Button>
          )}
          <Button
            tooltip='Abbrechen'
            classes={'iconButton'}
            key={1}
            onClickHandler={() => setShowModal(true)}
          >
            <i className='fas fa-times fa-2x color-red' />
          </Button>
          {reports.length > 0 && (
            <DropDown icon='fas fa-print fa-lg' title='Drucken'>
              {reports.map((report, index) => {
                return (
                  <span
                    key={index}
                    id={'' + report.id}
                    onClick={() => printReport(report)}
                  >
                    {report.label}
                  </span>
                );
              })}
            </DropDown>
          )}
          {canSaveTemplate && !denyOrderEdit && (
            <Button
              tooltip='Als Vorlage speichern'
              classes={'iconButton'}
              key={3}
              onClickHandler={() => setShowModalVorlageEdit(true)}
            >
              <i className='fas fa-file-export fa-lg' />
            </Button>
          )}
          {config.isPreisermittlung && (
            <Button
              tooltip='Tagespreis'
              classes={'iconButton'}
              key={8}
              disabled={disablePreisButton()}
              onClickHandler={() => setShowModalPreisanzeige(true)}
            >
              <i className='fas fa-money-bill fa-2x' />
            </Button>
          )}
          {isHauptmandant && (
            <Select
              className='adr-mandant'
              headerTitle='Mandant'
              onChangeHandler={wechselMandant}
              selectedOptionId={
                currentMandantId
                  ? Number(currentMandantId)
                  : auftragserfassung.mandant?.id
              }
              selectData={toSelectOptions(
                mandanten,
                nameof<MandantSummary>('name'),
                false
              )}
              selectionDenied={
                !!auftragserfassung.copyId ||
                !!auftragserfassung.vorlageAuftragId ||
                !!auftragId
              }
            />
          )}
        </Toolbar>
        <div className='status'>
          <div className={'datum-auftragnr-partnerref'}>
            <span>
              Erfassungsdatum:{' '}
              <strong>
                {/*{auftragserfassung.id && !auftragserfassung.copyId*/}
                {auftragserfassung.datum
                  ? isoDateToDateAndTime(auftragserfassung.datum)
                  : isoDateToDateAndTime(
                      convertToLocaleDateAndTime(new Date())
                    )}
              </strong>
            </span>
            {/*{auftragserfassung.id && (*/}
            {auftragserfassung.erfasser?.name && (
              <div className='text_lower'>
                <p>
                  erfasst von:{' '}
                  <strong>
                    {auftragserfassung.erfasser?.name
                      ? auftragserfassung.erfasser.name
                      : auftragserfassung.currentBenutzer?.name}
                  </strong>
                </p>
              </div>
            )}
          </div>
          {/*{auftragserfassung.id && (*/}
          {auftragserfassung.spedeigennr && (
            <Fragment>
              <Vr />
              <span>
                Auftragsnummer: <strong>{auftragserfassung.spedeigennr}</strong>
              </span>
            </Fragment>
          )}
          {auftragserfassung.partnerreferenz && (
            <Fragment>
              <Vr />
              <span>
                Partnerreferenz:{' '}
                <strong>{auftragserfassung.partnerreferenz}</strong>
              </span>
            </Fragment>
          )}
        </div>
        <Auftragoverview />
        <GridCellWrapper
          classes='versender'
          label={getWorktabsVersender()}
          saveUserAnsicht={() => {
            null;
          }}
        >
          {activeVersenderTab === VERSENDER && (
            <Fragment>
              <AdresseFelder
                addressType={VERSENDER}
                adresse={auftragserfassung.adressen.find(
                  (adresse: any) => adresse.typ === VERSENDER
                )}
                setAdresse={setAdresse}
                isCreate={auftragserfassung.isCreateAbsender}
                setIsCreate={setIsCreateAbsender}
              />
              <hr />
              <VersenderWrapper />
            </Fragment>
          )}
          {activeVersenderTab === ABWEICHENDE_BELADESTELLE && (
            <Fragment>
              <AdresseFelder
                addressType={ABWEICHENDE_BELADESTELLE}
                adresse={auftragserfassung.adressen.find(
                  (adresse: any) => adresse.typ === ABWEICHENDE_BELADESTELLE
                )}
                setAdresse={setAdresse}
                isCreate={auftragserfassung.isCreateAbsender}
                setIsCreate={setIsCreateAbsender}
              />
              <hr />
              <VersenderWrapper />
            </Fragment>
          )}
          {activeVersenderTab ===
            ABWEICHENDER_RECHNUNGSEMPFAENGER_VERSENDER && (
            <Fragment>
              <AdresseFelder
                addressType={ABWEICHENDER_RECHNUNGSEMPFAENGER_VERSENDER}
                adresse={auftragserfassung.adressen.find(
                  (adresse: any) =>
                    adresse.typ === ABWEICHENDER_RECHNUNGSEMPFAENGER_VERSENDER
                )}
                setAdresse={setAdresse}
                isCreate={auftragserfassung.isCreateAbsender}
                setIsCreate={setIsCreateAbsender}
              />
              <hr />
              <VersenderWrapper />
            </Fragment>
          )}
          {activeVersenderTab === NEUTRALE_ABSENDERADRESSE && (
            <Fragment>
              <AdresseFelder
                addressType={NEUTRALE_ABSENDERADRESSE}
                adresse={auftragserfassung.adressen.find(
                  (adresse: any) => adresse.typ === NEUTRALE_ABSENDERADRESSE
                )}
                setAdresse={setAdresse}
                isCreate={auftragserfassung.isCreateAbsender}
                setIsCreate={setIsCreateAbsender}
              />
              <hr />
              <VersenderWrapper />
            </Fragment>
          )}
          {activeVersenderTab === NACHNAHME_EMPFAENGER && (
            <Fragment>
              <AdresseFelder
                addressType={NACHNAHME_EMPFAENGER}
                adresse={auftragserfassung.adressen.find(
                  (adresse: any) => adresse.typ === NACHNAHME_EMPFAENGER
                )}
                setAdresse={setAdresse}
                isCreate={auftragserfassung.isCreateAbsender}
                setIsCreate={setIsCreateAbsender}
              />
              <hr />
              <NachnahmeWrapper />
            </Fragment>
          )}
        </GridCellWrapper>

        <GridCellWrapper
          classes='empfaenger'
          label={getWorktabsEmpfaenger()}
          saveUserAnsicht={() => {
            null;
          }}
        >
          {activeEmpfaengerTab === EMPFAENGER && (
            <AdresseFelder
              addressType={EMPFAENGER}
              adresse={auftragserfassung.adressen.find(
                (adresse: any) => adresse.typ === EMPFAENGER
              )}
              setAdresse={setAdresse}
              isCreate={auftragserfassung.isCreateEmpfaenger}
              setIsCreate={setIsCreateEmpfaenger}
            />
          )}
          {activeEmpfaengerTab ===
            ABWEICHENDER_RECHNUNGSEMPFAENGER_EMPFAENGER && (
            <AdresseFelder
              addressType={ABWEICHENDER_RECHNUNGSEMPFAENGER_EMPFAENGER}
              adresse={auftragserfassung.adressen.find(
                (adresse: any) =>
                  adresse.typ === ABWEICHENDER_RECHNUNGSEMPFAENGER_EMPFAENGER
              )}
              setAdresse={setAdresse}
              isCreate={auftragserfassung.isCreateEmpfaenger}
              setIsCreate={setIsCreateEmpfaenger}
            />
          )}
          <hr />
          <div className={'wrapper-adresse-bottom'}>
            <InputFieldText
              name={nameof<Auftrag>('empfaengerReferenz')}
              maxlength={35}
              tooltip={'max. 35 Zeichen'}
              label='Empfängerreferenz'
              classes='absenderreferenz-empfaengerreferenz_full'
              onChangeHandler={setEmpfaengerreferenz}
              value={auftragserfassung.empfaengerreferenz}
            />
            <div className={'adress-datum'}>
              <InputFieldText
                name={'abholdatumkleinerodergleichzustelldatum'}
                label='Zustellung'
                classes='datum'
                inputType='date'
                onChangeHandler={setEntladedatum}
                value={auftragserfassung.entladedatum}
                readonly={zustelldatumEditDeny}
              />
              {!isDisableUhrzeitfelder && (
                <div className={'von-bis'}>
                  <InputFieldText
                    label='von'
                    classes='von'
                    inputType='time'
                    onChangeHandler={setEntladezeitVon}
                    value={auftragserfassung.entladezeitVon?.toString() ?? ''}
                  />
                  <InputFieldText
                    name={'zustellzeitvonkleinerbis'}
                    label='bis'
                    classes='bis'
                    inputType='time'
                    onChangeHandler={setEntladezeitBis}
                    value={auftragserfassung.entladezeitBis?.toString() ?? ''}
                  />
                </div>
              )}
              <Select
                className='zustellkennzeichen'
                headerTitle='Zustellart'
                onChangeHandler={setZustellkennzeichen}
                selectedOptionId={
                  auftragserfassung.zustellkennzeichen ?? undefined
                }
                selectData={toSelectOptions(
                  zustellkennzeichen,
                  nameof<ZustellkennzeichenModel>('langBezeichnung'),
                  true,
                  true
                )}
                readonly={!!auftragserfassung.terminkennzeichen}
              />
            </div>
          </div>
        </GridCellWrapper>
        <Allgemein />
        <Services
          label={isBEXITY ? 'Services (kostenpfl.)' : 'Services'}
          classes='services-kostenpfl'
          isKostenpfl={true}
        />
        {config.isServicesInternSendungen && (
          <Services
            label='Services (Intern. Sendungen)'
            classes='services-intern-sendungen'
            isKostenpfl={false}
          />
        )}
        <Hinweise />
        <Auftragspositionen />
      </div>
      <Modal
        show={show}
        closeHandler={handleClose}
        titel='Abbrechen'
        description='Möchten Sie diesen Auftrag wirklich abbrechen?'
      >
        <div className='modal-btn-group'>
          <button
            className='modal-btn'
            onClick={() =>
              config.directly_back_2list //#85036
                ? auftragserfassungAbbrechen(history)
                : !!auftragserfassung.id
                ? auftragserfassungAbbrechen(history)
                : auftragserfassungAbbrechen()
            }
          >
            Ja
          </button>
          <button className='modal-btn' onClick={() => handleClose()}>
            Nein
          </button>
        </div>
      </Modal>
      <Modal
        show={showModalVorlageEdit}
        closeHandler={closeAuftragsvorlage}
        closeByOutsideClick={false}
        titel={'Auftragsvorlage Erfassen'}
        height={'300px'}
        width={'500px'}
      >
        <Auftragsvorlageerfassung close={closeAuftragsvorlage} />
      </Modal>
      <Modal
        show={showModalPreisanzeige}
        closeHandler={closePreisanzeige}
        closeByOutsideClick={false}
        titel={'Tagespreis Angebot'}
      >
        <Preisanzeige close={closePreisanzeige} />
      </Modal>
    </Fragment>
  );
};

const mapStateToProps = (state: StateModel) => ({
  auftragserfassung: state.Auftragserfassung,
  stammLademittel: state.Stammdaten.lademittel,
  notifications: state.Notifications,
  stammVerpackungen: state.Stammdaten.verpackungen,
  activeTab: state.Routing.activeTab,
  reports: state.Stammdaten.reports,
  zustellkennzeichen: state.Stammdaten.zustellkennzeichen,
  isHauptmandant: state.UserSession.isHauptmandant,
  isAdmin: state.UserSession.isAdmin,
  isMain: state.UserSession.isMain,
  currentMandantId: state.UserSession.currentMandantId,
  mandanten: state.Stammdaten.mandanten,
  stammWaehrungen: state.Stammdaten.waehrungen,
  currentMandant: state.Stammdaten.mandanten[0],
  isEditVorlage: state.UserSession.isEditVorlage,
  isDisableUhrzeitfelder: state.Config.isDisableUhrzeitfelder,
  isAuftragEdit: state.UserSession.isAuftragEdit,
  version: state.UserSession.version,
  config: state.Config,
  dynamicServices: state.Stammdaten.dynamicServices,
  auth_user_id: state.Auth.userID,
});

export default connect(mapStateToProps, {
  getAuftragById,
  getAuftragCopyByAuftragId,
  saveAuftrag,
  updateAuftrag,
  resetAuftragserfassung,
  setActiveTab,
  getAnlieferkennzeichen,
  getZustellkennzeichen,
  getReports,
  printReports,
  setEntladedatum,
  setEntladezeitVon,
  setEntladezeitBis,
  setEmpfaengerreferenz,
  setAuftragField,
  setZustellkennzeichen,
  getMandantenByHauptmandant,
  getAdresseOfMandant,
  resetAuftragsvorlageerfassung,
  createAdresse,
  setModalConfig,
  setNotificationField,
  setAdresse,
  setCurrentMandantId,
  addNotifications,
  getAuftragByVorlageAuftragId,
  getCurrentBenutzerById,
  getDynamicAuftragServices,
})(withRouter(Auftragserfassung));
